import { render, staticRenderFns } from "./DataModelTreeNode.vue?vue&type=template&id=05f457da&"
import script from "./DataModelTreeNode.vue?vue&type=script&lang=ts&"
export * from "./DataModelTreeNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports